// import React from "react";
// // TODO: add screenshots, then uncomment the imports and the matching entries in `sectionImages`
// // import alertUiImg1 from "../../../assets/releasenote51.png";
// // import alertUiImg2 from "../../../assets/releasenote52.png";
// // import alertHistoryImg from "../../../assets/releasenote53.png";
// // import dbStatementsImg from "../../../assets/releasenote54.png";
// // import exceptionAnalysisImg from "../../../assets/releasenote55.png";

// export function renderNetraaAPMReleaseNotes5() {
//   return <RenderNetraaAPMReleaseNotes />;
// }

// function RenderNetraaAPMReleaseNotes() {
//   const [zoomImage, setZoomImage] = React.useState(null);

//   const releaseMetrics = [
//     { label: "Modules Updated", value: "08" },
//     { label: "Key Areas", value: "08" },
//     { label: "Security & Governance", value: "0" },
//     { label: "Impact Score", value: "9.3" },
//   ];

//   const releasePills = [
//     "OTLP Data Ingestion",
//     "Alert Module Enhancements",
//     "Database Statements Dashboard",
//     "Exception Analysis",
//   ];

//   // Images per section title. Add imports above and uncomment entries below.
//   const sectionImages = {
//     // "Alert UI & Alert History": [
//     //   { src: alertUiImg1, alt: "Alert UI" },
//     //   { src: alertUiImg2, alt: "Alert UI Table Layout" },
//     //   { src: alertHistoryImg, alt: "Advanced Alert History" },
//     // ],
//     // "Database Statements Dashboard": [
//     //   { src: dbStatementsImg, alt: "Database Statements Dashboard" },
//     // ],
//     // "Exception Analysis": [
//     //   { src: exceptionAnalysisImg, alt: "Exception Analysis" },
//     // ],
//   };

//   const majorFeatureEnhancements = [
//     {
//       number: 1,
//       title: "OTLP Data Ingestion Support",
//       subsections: [
//         {
//           title: "Overview",
//           items: [
//             "Netra APM AOP now supports data ingestion in OpenTelemetry Protocol (OTLP) format, making it easier to bring in telemetry from OpenTelemetry-based environments.",
//           ],
//         },
//         {
//           title: "Trace Ingestion",
//           items: [
//             "OpenTelemetry Collector (OTel Collector) agents can now send traces directly to AOP.",
//             "Traces ingested through OTLP are processed and displayed in AOP in the same way as traces collected through Netra native agents.",
//           ],
//         },
//         {
//           // TODO: Add link for log ingestion documentation
//           title: "Log Ingestion & Correlation",
//           items: [
//             "Log ingestion through OTLP is also supported.",
//             "Trace-to-log correlation is now available, enabling users to navigate between related traces and logs for easier troubleshooting and root-cause analysis.",
//           ],
//         },
//       ],
//     },
//     {
//       number: 2,
//       title: "Virtual DB Query Error Identification",
//       subsections: [
//         {
//           title: "Overview",
//           items: [
//             "Virtual DB queries now carry an additional field that flags failing queries.",
//           ],
//         },
//         {
//           title: "is_error Field",
//           items: [
//             "Virtual DB queries now include an additional is_error field that indicates whether an individual database query encountered an error.",
//             "Makes it easier to identify problematic queries during transaction and trace analysis.",
//             "Provides better visibility into database-level failures.",
//           ],
//         },
//       ],
//     },
//     {
//       number: 3,
//       title: "Java Agent – Ignore Unnecessary Trace Endpoints",
//       subsections: [
//         {
//           title: "Overview",
//           items: [
//             "The Netra Java Agent now allows users to exclude unnecessary trace endpoints from monitoring.",
//           ],
//         },
//         {
//           // TODO: Paste link to the endpoint excluding document
//           title: "Endpoint Exclusion",
//           items: [
//             "Configured endpoints can be ignored from trace collection.",
//             "Ignored endpoints do not contribute to Success Rate (SR) or other key application metrics.",
//             "Helps reduce unnecessary trace data and keeps application metrics focused on relevant business endpoints.",
//           ],
//         },
//       ],
//     },
//     {
//       number: 4,
//       title: "Alert Module Enhancements",
//       subsections: [
//         {
//           title: "Overview",
//           items: [
//             "The Alert Module has been extended with log-based alerting, custom metric alerts, and a simpler configuration experience.",
//           ],
//         },
//         {
//           title: "SRG Log-Based Alerts",
//           items: [
//             "Alerts can now be configured based on SRG logs.",
//             "Error Log Count – Trigger an alert when the number of error logs crosses a configured threshold.",
//             "Log Content – Trigger an alert when specific content or patterns are detected in log messages.",
//           ],
//         },
//         {
//           title: "Custom Alert Support",
//           items: [
//             "Added alerting for database, host, and VM metrics, including slow queries, service status, process usage, availability, memory, and host restart events.",
//           ],
//         },
//         {
//           title: "Custom Database Alerts",
//           items: [
//             "Added alerts for MSSQL slow statements.",
//             "Added alerts for Virtual Database slow statements, to help identify performance issues early.",
//           ],
//         },
//         {
//           title: "Improved Alert Configuration",
//           items: [
//             "Simplified alert setup by showing only the settings relevant to each metric.",
//             "Improved handling of historical data evaluation.",
//           ],
//         },
//       ],
//     },
//     {
//       number: 5,
//       title: "Alert UI & Alert History",
//       subsections: [
//         {
//           title: "Overview",
//           items: [
//             "The alert pages have been redesigned for faster navigation, clearer status visibility, and easier analysis and reporting.",
//           ],
//         },
//         {
//           title: "Alert UI Improvements",
//           items: [
//             "Redesigned the See All Alerts and Alert History pages.",
//             "Added improved filters, search, and status summaries.",
//             "Introduced an improved table layout and easier navigation.",
//           ],
//         },
//         {
//           title: "Advanced Alert History",
//           items: [
//             "Added improved sorting, filtering, and pagination.",
//             "Added keyword search.",
//             "Added CSV and Excel export for easier alert analysis and reporting.",
//           ],
//         },
//       ],
//     },
//     {
//       number: 6,
//       title: "Database Statements Dashboard",
//       subsections: [
//         {
//           title: "Overview",
//           items: [
//             "A new dashboard gives teams a single place to examine database query activity.",
//           ],
//         },
//         {
//           title: "Query Analysis",
//           items: [
//             "Introduced a new dashboard to view, search, filter, and analyse database queries.",
//             "Added response-time and execution trends for queries.",
//           ],
//         },
//       ],
//     },
//     {
//       number: 7,
//       title: "Exception Analysis",
//       subsections: [
//         {
//           title: "Overview",
//           items: [
//             "The Exception Analysis module helps teams analyse application errors and move quickly to the related traces.",
//           ],
//         },
//         {
//           title: "Error Insight",
//           items: [
//             "Identify application errors and track exception trends.",
//             "View the applications affected by each exception.",
//             "Navigate directly to the related traces for faster root-cause analysis.",
//           ],
//         },
//       ],
//     },
//     {
//       number: 8,
//       title: "Infrastructure Plugin Optimization",
//       subsections: [
//         {
//           title: "Overview",
//           items: [
//             "The infrastructure monitoring plugin has been optimized for a lighter footprint.",
//           ],
//         },
//         {
//           title: "Plugin Optimization",
//           items: [
//             "Optimized the infrastructure monitoring plugin to reduce memory overhead.",
//             "Improved resource utilization of the plugin on monitored hosts.",
//           ],
//         },
//       ],
//     },
//   ];

//   const notes = [
//     "OTLP Data Ingestion Support: traces and logs can be ingested in OTLP format, with trace-to-log correlation for faster troubleshooting.",
//     "Virtual DB Query Error Identification: a new is_error field flags failing Virtual DB queries.",
//     "Java Agent – Ignore Unnecessary Trace Endpoints: configured endpoints are excluded from trace collection and do not contribute to Success Rate (SR) or other key application metrics.",
//     "Alert Module Enhancements: SRG log-based alerts, custom database, host, and VM metric alerts, MSSQL and Virtual Database slow statement alerts, and simpler alert configuration.",
//     "Alert UI & Alert History: redesigned alert pages with improved filters, search, status summaries, sorting, pagination, and CSV/Excel export.",
//     "Database Statements Dashboard: a single place to view, search, filter, and analyse database queries with response-time and execution trends.",
//     "Exception Analysis: track exception trends, see affected applications, and navigate directly to related traces.",
//     "Infrastructure Plugin Optimization: reduced memory overhead and improved resource utilization on monitored hosts.",
//   ];

//   return (
//     <div>
//       <main className="transition-opacity duration-300">
//         <div className="mx-auto">
//           <section className="relative scroll-mt-24" id="release-details">
//             <div>
//               <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
//                 <span className="h-2 w-2 rounded-full bg-orange-500" />
//                 Release Notes 2026.09
//               </div>

//               <div className="flex items-center justify-between gap-4">
//                 <h1 className="text-3xl font-black tracking-tight sm:text-4xl">
//                   <span className="bg-gradient-to-r from-orange-500 via-red-500 to-rose-600 bg-clip-text text-transparent">
//                     Netraa APM Release Notes
//                   </span>
//                 </h1>
//               </div>

//               <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg dark:text-slate-300">
//                 Netraa APM – Release Notes
//               </p>
//             </div>
//           </section>

//           <section className="scroll-mt-24 px-0 py-4" id="intro">
//             <div className="rounded-3xl border border-orange-200/70 bg-gradient-to-br from-orange-50 via-white to-white p-6 shadow-sm dark:border-orange-500/15 dark:from-orange-500/10 dark:via-slate-950/30 dark:to-slate-950/30">
//               <div className="mb-4 flex items-center gap-3">
//                 <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-orange-500 to-red-500 text-white shadow-lg shadow-orange-500/25">
//                   ✦
//                 </div>
//                 <div>
//                   <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
//                     Introduction
//                   </h2>
//                   <p className="text-sm text-slate-500 dark:text-slate-400">
//                     What this release brings to the platform.
//                   </p>
//                 </div>
//               </div>

//               <p className="text-sm leading-7 text-slate-600 dark:text-slate-300 sm:text-base">
//                 This release strengthens Netra APM across eight key areas,
//                 spanning OTLP data ingestion, Virtual DB query error
//                 identification, Java agent endpoint exclusion, alert module
//                 enhancements, redesigned alert pages and history, a new
//                 database statements dashboard, exception analysis, and
//                 infrastructure plugin optimization. Highlights include
//                 OpenTelemetry trace and log ingestion with trace-to-log
//                 correlation, an is_error field for Virtual DB queries,
//                 log-based and custom metric alerts, CSV and Excel export for
//                 alert history, and a lighter infrastructure monitoring
//                 plugin.
//               </p>

//               <div className="mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
//                 {releasePills.map((item) => (
//                   <div
//                     key={item}
//                     className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 shadow-sm dark:border-white/10 dark:bg-slate-900/50 dark:text-slate-200"
//                   >
//                     {item}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </section>

//           <section className="mt-10 w-full scroll-mt-24" id="analytics">
//             <div className="mx-auto">
//               <h4 className="mb-4 text-xl font-bold text-slate-900 dark:text-white">
//                 Release Analytics
//               </h4>

//               <div
//                 className="
//       glass-card
//       rounded-2xl
//       border border-slate-200 dark:border-white/10
//       bg-white/90 p-5 backdrop-blur-xl
//       transition-all duration-500
//       hover:-translate-y-1 hover:shadow-2xl
//       dark:bg-white/5
//       sm:p-6
//     "
//               >
//                 <div className="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
//                   {releaseMetrics.map((item, i) => (
//                     <div
//                       key={i}
//                       className="
//               rounded-xl
//               border border-slate-200 bg-white p-3
//               shadow-sm
//               transition-all duration-300
//               hover:-translate-y-1 hover:scale-[1.02] hover:shadow-md
//               dark:border-white/10 dark:bg-white/5
//             "
//                     >
//                       <div className="mb-1 text-[11px] text-slate-500 dark:text-slate-400">
//                         {item.label}
//                       </div>

//                       <div
//                         className="
//               text-lg font-bold text-orange-600
//               dark:bg-gradient-to-r dark:from-orange-500 dark:to-rose-600
//               dark:bg-clip-text dark:text-transparent
//             "
//                       >
//                         {item.value}
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 <div className="space-y-4">
//                   <div>
//                     <div className="mb-1 flex justify-between text-sm text-slate-700 dark:text-slate-300">
//                       <span>Deployment Readiness</span>
//                       <span className="font-semibold text-orange-500">98%</span>
//                     </div>

//                     <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
//                       <div
//                         className="
//               h-full w-[98%]
//               bg-gradient-to-r from-orange-500 to-rose-600
//               shadow-[0_0_8px_rgba(255,120,120,0.4)]
//               transition-all duration-700
//             "
//                       />
//                     </div>
//                   </div>

//                   <div>
//                     <div className="mb-1 flex justify-between text-sm text-slate-700 dark:text-slate-300">
//                       <span>Health Meter</span>
//                       <span className="font-semibold text-rose-500">Optimal</span>
//                     </div>

//                     <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
//                       <div
//                         className="
//               h-full w-full
//               bg-gradient-to-r from-orange-500 to-rose-600
//               shadow-[0_0_8px_rgba(255,120,120,0.4)]
//               transition-all duration-700
//             "
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>

//           <section className="mb-12 mt-12" id="overview">
//             <h2 className="mb-4 text-xl font-bold text-slate-900 dark:text-white">
//               Release Details
//             </h2>

//             <div className="overflow-x-auto rounded-2xl border border-slate-200 dark:border-white/10">
//               <table className="w-full text-left text-sm border-collapse">
//                 <thead className="bg-slate-50 dark:bg-white/5">
//                   <tr>
//                     <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
//                       Release Month
//                     </th>
//                     <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
//                       Organization
//                     </th>
//                     <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
//                       Prepared By
//                     </th>
//                   </tr>
//                 </thead>

//                 <tbody className="divide-y divide-slate-200 dark:divide-white/10">
//                   <tr className="bg-white dark:bg-transparent">
//                     <td className="px-5 py-4 font-medium text-orange-600 dark:text-orange-400 border border-slate-200 dark:border-white/10">
//                       September 2026
//                     </td>
//                     <td className="px-5 py-4 text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-white/10">
//                       ApMoSys Products Pvt. Ltd.
//                     </td>
//                     <td className="px-5 py-4 text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-white/10">
//                       Netra APM Product Team
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </section>

//           <section className="scroll-mt-24" id="enhancements">
//             <div className="mb-6 flex items-end justify-between gap-4">
//               <div>
//                 <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
//                   Key Enhancements
//                 </h2>
//                 <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
//                   Exact feature list from the release notes.
//                 </p>
//               </div>
//             </div>

//             <div className="space-y-4">
//               {majorFeatureEnhancements.map((section) => (
//                 <article
//                   key={section.title}
//                   className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-slate-900/60"
//                 >
//                   <div className="flex items-start gap-4">
//                     <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-red-500 text-sm font-bold text-white shadow-md shadow-orange-500/20">
//                       {section.number}
//                     </div>

//                     <div className="min-w-0 w-full">
//                       <h3 className="text-base font-bold text-slate-900 dark:text-white">
//                         {section.title}
//                       </h3>

//                       <div className="mt-3 space-y-4">
//                         {section.subsections.map((sub) => (
//                           <div key={sub.title}>
//                             <h4 className="text-sm font-semibold text-orange-600 dark:text-orange-400">
//                               {sub.title}
//                             </h4>
//                             <ul className="mt-2 space-y-2">
//                               {sub.items.map((point) => (
//                                 <li
//                                   key={point}
//                                   className="flex gap-3 text-sm leading-6 text-slate-600 dark:text-slate-300"
//                                 >
//                                   <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-orange-500" />
//                                   <span>{point}</span>
//                                 </li>
//                               ))}
//                             </ul>
//                           </div>
//                         ))}

//                         {/* Section images (filled via sectionImages above) */}
//                         {(sectionImages[section.title] || []).length > 0 && (
//                           <div className="mt-4 space-y-4">
//                             {sectionImages[section.title].map((img) => (
//                               <img
//                                 key={img.alt}
//                                 src={img.src}
//                                 alt={img.alt}
//                                 className="mt-4 w-full border border-slate-200 shadow-md dark:border-white/10 cursor-zoom-in transition-all duration-300 hover:shadow-xl hover:scale-[1.01]"
//                                 onClick={() => setZoomImage(img.src)}
//                               />
//                             ))}
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </article>
//               ))}
//             </div>
//           </section>

//           <section className="py-8 scroll-mt-24" id="notes">
//             <div className="grid gap-8 lg:grid-cols-2">
//               <div>
//                 <h2 className="text-2xl font-bold text-slate-900 dark:text-white">
//                   Additional Notes
//                 </h2>
//                 <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
//                   Extra content kept in the layout.
//                 </p>

//                 <ul className="mt-6 space-y-4">
//                   {notes.map((item) => (
//                     <li key={item} className="flex items-start gap-3">
//                       <span className="mt-1 h-2 w-2 rounded-full bg-orange-500" />
//                       <span className="text-sm leading-6 text-slate-600 dark:text-slate-300">
//                         {item}
//                       </span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>

//               <div className="rounded-2xl bg-gradient-to-br from-orange-500 to-red-600 p-6 text-white shadow-lg">
//                 <h3 className="text-xl font-bold">Release Summary</h3>

//                 <p className="mt-3 text-sm leading-6 text-white/90">
//                   This release strengthens Netra APM across eight key areas,
//                   delivering OTLP data ingestion, Virtual DB query error
//                   identification, Java agent endpoint exclusion, expanded
//                   alerting with redesigned alert pages and history, a new
//                   database statements dashboard, exception analysis, and a
//                   lighter infrastructure monitoring plugin.
//                 </p>

//                 <div className="mt-5 text-sm font-semibold">
//                   Status: Major enhancements and platform improvements
//                 </div>
//               </div>
//             </div>
//           </section>
//         </div>
//       </main>

//       {/* Zoom modal */}
//       {zoomImage && (
//         <div
//           className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
//           onClick={() => setZoomImage(null)}
//         >
//           <img
//             src={zoomImage}
//             alt="Zoomed Preview"
//             className="max-w-[95vw] max-h-[90vh] object-contain transition-all duration-300"
//             onClick={(e) => e.stopPropagation()}
//           />
//         </div>
//       )}
//     </div>
//   );
// }


import React from "react";

/* =====================================================================
   PASTE LINKS HERE (leave "" until you have the link)
   ===================================================================== */
// Link for log ingestion documentation
const logIngestionDocLink = ""; // PASTE LINK HERE
// Link for the endpoint excluding document
const endpointExclusionDocLink = ""; // PASTE LINK HERE

/* =====================================================================
   PASTE IMAGES HERE
   Replace each `const ... = null;` line with an import, e.g.
   import alertUiImg1 from "../../../assets/releasenote51.png";
   ===================================================================== */
const alertUiImg1 = null; // Alert UI Improvements - image 1 (See All Alerts / Alert History redesign)
const alertUiImg2 = null; // Alert UI Improvements - image 2 (table layout / navigation)
const alertHistoryImg = null; // Advanced Alert History image
const dbStatementsImg = null; // Database Statements Dashboard image
const exceptionAnalysisImg = null; // Exception Analysis image

export function renderNetraaAPMReleaseNotes5() {
  return <RenderNetraaAPMReleaseNotes />;
}

function RenderNetraaAPMReleaseNotes() {
  const [zoomImage, setZoomImage] = React.useState(null);

  const releaseMetrics = [
    { label: "Modules Updated", value: "08" },
    { label: "Key Areas", value: "08" },
    { label: "Security & Governance", value: "0" },
    { label: "Impact Score", value: "9.3" },
  ];

  const releasePills = [
    "OTLP Data Ingestion",
    "Alert Module Enhancements",
    "Database Statements Dashboard",
    "Exception Analysis",
  ];

  const majorFeatureEnhancements = [
    {
      number: 1,
      title: "OTLP Data Ingestion Support",
      subsections: [
        {
          title: "Overview",
          items: [
            "Netra APM AOP now supports data ingestion in OpenTelemetry Protocol (OTLP) format, making it easier to bring in telemetry from OpenTelemetry-based environments.",
          ],
        },
        {
          title: "Trace Ingestion",
          items: [
            "OpenTelemetry Collector (OTel Collector) agents can now send traces directly to AOP.",
            "Traces ingested through OTLP are processed and displayed in AOP in the same way as traces collected through Netra native agents.",
          ],
        },
        {
          title: "Log Ingestion & Correlation",
          items: [
            "Log ingestion through OTLP is also supported.",
            "Trace-to-log correlation is now available, enabling users to navigate between related traces and logs for easier troubleshooting and root-cause analysis.",
          ],
          link: { label: "Read log ingestion documentation", href: logIngestionDocLink },
        },
      ],
    },
    {
      number: 2,
      title: "Virtual DB Query Error Identification",
      subsections: [
        {
          title: "Overview",
          items: [
            "Virtual DB queries now carry an additional field that flags failing queries.",
          ],
        },
        {
          title: "is_error Field",
          items: [
            "Virtual DB queries now include an additional is_error field that indicates whether an individual database query encountered an error.",
            "Makes it easier to identify problematic queries during transaction and trace analysis.",
            "Provides better visibility into database-level failures.",
          ],
        },
      ],
    },
    {
      number: 3,
      title: "Java Agent – Ignore Unnecessary Trace Endpoints",
      subsections: [
        {
          title: "Overview",
          items: [
            "The Netra Java Agent now allows users to exclude unnecessary trace endpoints from monitoring.",
          ],
        },
        {
          title: "Endpoint Exclusion",
          items: [
            "Configured endpoints can be ignored from trace collection.",
            "Ignored endpoints do not contribute to Success Rate (SR) or other key application metrics.",
            "Helps reduce unnecessary trace data and keeps application metrics focused on relevant business endpoints.",
          ],
          link: { label: "Read endpoint exclusion documentation", href: endpointExclusionDocLink },
        },
      ],
    },
    {
      number: 4,
      title: "Alert Module Enhancements",
      subsections: [
        {
          title: "Overview",
          items: [
            "The Alert Module has been extended with log-based alerting, custom metric alerts, and a simpler configuration experience.",
          ],
        },
        {
          title: "SRG Log-Based Alerts",
          items: [
            "Alerts can now be configured based on SRG logs.",
            "Error Log Count – Trigger an alert when the number of error logs crosses a configured threshold.",
            "Log Content – Trigger an alert when specific content or patterns are detected in log messages.",
          ],
        },
        {
          title: "Custom Alert Support",
          items: [
            "Added alerting for database, host, and VM metrics, including slow queries, service status, process usage, availability, memory, and host restart events.",
          ],
        },
        {
          title: "Custom Database Alerts",
          items: [
            "Added alerts for MSSQL slow statements.",
            "Added alerts for Virtual Database slow statements, to help identify performance issues early.",
          ],
        },
        {
          title: "Improved Alert Configuration",
          items: [
            "Simplified alert setup by showing only the settings relevant to each metric.",
            "Improved handling of historical data evaluation.",
          ],
        },
      ],
    },
    {
      number: 5,
      title: "Alert UI & Alert History",
      subsections: [
        {
          title: "Overview",
          items: [
            "The alert pages have been redesigned for faster navigation, clearer status visibility, and easier analysis and reporting.",
          ],
        },
        {
          title: "Alert UI Improvements",
          items: [
            "Redesigned the See All Alerts and Alert History pages.",
            "Added improved filters, search, and status summaries.",
            "Introduced an improved table layout and easier navigation.",
          ],
          images: [
            { src: alertUiImg1, alt: "Alert UI Redesign" },
            { src: alertUiImg2, alt: "Alert UI Table Layout" },
          ],
        },
        {
          title: "Advanced Alert History",
          items: [
            "Added improved sorting, filtering, and pagination.",
            "Added keyword search.",
            "Added CSV and Excel export for easier alert analysis and reporting.",
          ],
          images: [{ src: alertHistoryImg, alt: "Advanced Alert History" }],
        },
      ],
    },
    {
      number: 6,
      title: "Database Statements Dashboard",
      subsections: [
        {
          title: "Overview",
          items: [
            "A new dashboard gives teams a single place to examine database query activity.",
          ],
        },
        {
          title: "Query Analysis",
          items: [
            "Introduced a new dashboard to view, search, filter, and analyse database queries.",
            "Added response-time and execution trends for queries.",
          ],
          images: [{ src: dbStatementsImg, alt: "Database Statements Dashboard" }],
        },
      ],
    },
    {
      number: 7,
      title: "Exception Analysis",
      subsections: [
        {
          title: "Overview",
          items: [
            "The Exception Analysis module helps teams analyse application errors and move quickly to the related traces.",
          ],
        },
        {
          title: "Error Insight",
          items: [
            "Identify application errors and track exception trends.",
            "View the applications affected by each exception.",
            "Navigate directly to the related traces for faster root-cause analysis.",
          ],
          images: [{ src: exceptionAnalysisImg, alt: "Exception Analysis" }],
        },
      ],
    },
    {
      number: 8,
      title: "Infrastructure Plugin Optimization",
      subsections: [
        {
          title: "Overview",
          items: [
            "The infrastructure monitoring plugin has been optimized for a lighter footprint.",
          ],
        },
        {
          title: "Plugin Optimization",
          items: [
            "Optimized the infrastructure monitoring plugin to reduce memory overhead.",
            "Improved resource utilization of the plugin on monitored hosts.",
          ],
        },
      ],
    },
  ];

  const notes = [
    "OTLP Data Ingestion Support: traces and logs can be ingested in OTLP format, with trace-to-log correlation for faster troubleshooting.",
    "Virtual DB Query Error Identification: a new is_error field flags failing Virtual DB queries.",
    "Java Agent – Ignore Unnecessary Trace Endpoints: configured endpoints are excluded from trace collection and do not contribute to Success Rate (SR) or other key application metrics.",
    "Alert Module Enhancements: SRG log-based alerts, custom database, host, and VM metric alerts, MSSQL and Virtual Database slow statement alerts, and simpler alert configuration.",
    "Alert UI & Alert History: redesigned alert pages with improved filters, search, status summaries, sorting, pagination, and CSV/Excel export.",
    "Database Statements Dashboard: a single place to view, search, filter, and analyse database queries with response-time and execution trends.",
    "Exception Analysis: track exception trends, see affected applications, and navigate directly to related traces.",
    "Infrastructure Plugin Optimization: reduced memory overhead and improved resource utilization on monitored hosts.",
  ];

  return (
    <div>
      <main className="transition-opacity duration-300">
        <div className="mx-auto">
          <section className="relative scroll-mt-24" id="release-details">
            <div>
              <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
                <span className="h-2 w-2 rounded-full bg-orange-500" />
                Release Notes 2026.09
              </div>

              <div className="flex items-center justify-between gap-4">
                <h1 className="text-3xl font-black tracking-tight sm:text-4xl">
                  <span className="bg-gradient-to-r from-orange-500 via-red-500 to-rose-600 bg-clip-text text-transparent">
                    Netraa APM Release Notes
                  </span>
                </h1>
              </div>

              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg dark:text-slate-300">
                Netraa APM – Release Notes
              </p>
            </div>
          </section>

          <section className="scroll-mt-24 px-0 py-4" id="intro">
            <div className="rounded-3xl border border-orange-200/70 bg-gradient-to-br from-orange-50 via-white to-white p-6 shadow-sm dark:border-orange-500/15 dark:from-orange-500/10 dark:via-slate-950/30 dark:to-slate-950/30">
              <div className="mb-4 flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-orange-500 to-red-500 text-white shadow-lg shadow-orange-500/25">
                  ✦
                </div>
                <div>
                  <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
                    Introduction
                  </h2>
                  <p className="text-sm text-slate-500 dark:text-slate-400">
                    What this release brings to the platform.
                  </p>
                </div>
              </div>

              <p className="text-sm leading-7 text-slate-600 dark:text-slate-300 sm:text-base">
                This release strengthens Netra APM across eight key areas,
                spanning OTLP data ingestion, Virtual DB query error
                identification, Java agent endpoint exclusion, alert module
                enhancements, redesigned alert pages and history, a new
                database statements dashboard, exception analysis, and
                infrastructure plugin optimization. Highlights include
                OpenTelemetry trace and log ingestion with trace-to-log
                correlation, an is_error field for Virtual DB queries,
                log-based and custom metric alerts, CSV and Excel export for
                alert history, and a lighter infrastructure monitoring
                plugin.
              </p>

              <div className="mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
                {releasePills.map((item) => (
                  <div
                    key={item}
                    className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 shadow-sm dark:border-white/10 dark:bg-slate-900/50 dark:text-slate-200"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="mt-10 w-full scroll-mt-24" id="analytics">
            <div className="mx-auto">
              <h4 className="mb-4 text-xl font-bold text-slate-900 dark:text-white">
                Release Analytics
              </h4>

              <div
                className="
      glass-card
      rounded-2xl
      border border-slate-200 dark:border-white/10
      bg-white/90 p-5 backdrop-blur-xl
      transition-all duration-500
      hover:-translate-y-1 hover:shadow-2xl
      dark:bg-white/5
      sm:p-6
    "
              >
                <div className="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
                  {releaseMetrics.map((item, i) => (
                    <div
                      key={i}
                      className="
              rounded-xl
              border border-slate-200 bg-white p-3
              shadow-sm
              transition-all duration-300
              hover:-translate-y-1 hover:scale-[1.02] hover:shadow-md
              dark:border-white/10 dark:bg-white/5
            "
                    >
                      <div className="mb-1 text-[11px] text-slate-500 dark:text-slate-400">
                        {item.label}
                      </div>

                      <div
                        className="
              text-lg font-bold text-orange-600
              dark:bg-gradient-to-r dark:from-orange-500 dark:to-rose-600
              dark:bg-clip-text dark:text-transparent
            "
                      >
                        {item.value}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="space-y-4">
                  <div>
                    <div className="mb-1 flex justify-between text-sm text-slate-700 dark:text-slate-300">
                      <span>Deployment Readiness</span>
                      <span className="font-semibold text-orange-500">98%</span>
                    </div>

                    <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
                      <div
                        className="
              h-full w-[98%]
              bg-gradient-to-r from-orange-500 to-rose-600
              shadow-[0_0_8px_rgba(255,120,120,0.4)]
              transition-all duration-700
            "
                      />
                    </div>
                  </div>

                  <div>
                    <div className="mb-1 flex justify-between text-sm text-slate-700 dark:text-slate-300">
                      <span>Health Meter</span>
                      <span className="font-semibold text-rose-500">Optimal</span>
                    </div>

                    <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
                      <div
                        className="
              h-full w-full
              bg-gradient-to-r from-orange-500 to-rose-600
              shadow-[0_0_8px_rgba(255,120,120,0.4)]
              transition-all duration-700
            "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-12 mt-12" id="overview">
            <h2 className="mb-4 text-xl font-bold text-slate-900 dark:text-white">
              Release Details
            </h2>

            <div className="overflow-x-auto rounded-2xl border border-slate-200 dark:border-white/10">
              <table className="w-full text-left text-sm border-collapse">
                <thead className="bg-slate-50 dark:bg-white/5">
                  <tr>
                    <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
                      Release Month
                    </th>
                    <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
                      Organization
                    </th>
                    <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
                      Prepared By
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-slate-200 dark:divide-white/10">
                  <tr className="bg-white dark:bg-transparent">
                    <td className="px-5 py-4 font-medium text-orange-600 dark:text-orange-400 border border-slate-200 dark:border-white/10">
                      September 2026
                    </td>
                    <td className="px-5 py-4 text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-white/10">
                      ApMoSys Products Pvt. Ltd.
                    </td>
                    <td className="px-5 py-4 text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-white/10">
                      Netra APM Product Team
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="scroll-mt-24" id="enhancements">
            <div className="mb-6 flex items-end justify-between gap-4">
              <div>
                <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
                  Key Enhancements
                </h2>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  Exact feature list from the release notes.
                </p>
              </div>
            </div>

            <div className="space-y-4">
              {majorFeatureEnhancements.map((section) => (
                <article
                  key={section.title}
                  className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-slate-900/60"
                >
                  <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-red-500 text-sm font-bold text-white shadow-md shadow-orange-500/20">
                      {section.number}
                    </div>

                    <div className="min-w-0 w-full">
                      <h3 className="text-base font-bold text-slate-900 dark:text-white">
                        {section.title}
                      </h3>

                      <div className="mt-3 space-y-4">
                        {section.subsections.map((sub) => (
                          <div key={sub.title}>
                            <h4 className="text-sm font-semibold text-orange-600 dark:text-orange-400">
                              {sub.title}
                            </h4>
                            <ul className="mt-2 space-y-2">
                              {sub.items.map((point) => (
                                <li
                                  key={point}
                                  className="flex gap-3 text-sm leading-6 text-slate-600 dark:text-slate-300"
                                >
                                  <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-orange-500" />
                                  <span>{point}</span>
                                </li>
                              ))}
                            </ul>

                            {/* Documentation link (shown only when the link is filled in) */}
                            {sub.link && sub.link.href && (
                              <a
                                href={sub.link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-3 inline-block text-sm font-semibold text-orange-600 underline hover:text-orange-700 dark:text-orange-400"
                              >
                                {sub.link.label}
                              </a>
                            )}

                            {/* Images (shown only when the image is filled in) */}
                            {(sub.images || [])
                              .filter((img) => img.src)
                              .map((img) => (
                                <img
                                  key={img.alt}
                                  src={img.src}
                                  alt={img.alt}
                                  className="mt-4 w-full border border-slate-200 shadow-md dark:border-white/10 cursor-zoom-in transition-all duration-300 hover:shadow-xl hover:scale-[1.01]"
                                  onClick={() => setZoomImage(img.src)}
                                />
                              ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section className="py-8 scroll-mt-24" id="notes">
            <div className="grid gap-8 lg:grid-cols-2">
              <div>
                <h2 className="text-2xl font-bold text-slate-900 dark:text-white">
                  Additional Notes
                </h2>
                <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                  Extra content kept in the layout.
                </p>

                <ul className="mt-6 space-y-4">
                  {notes.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <span className="mt-1 h-2 w-2 rounded-full bg-orange-500" />
                      <span className="text-sm leading-6 text-slate-600 dark:text-slate-300">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-2xl bg-gradient-to-br from-orange-500 to-red-600 p-6 text-white shadow-lg">
                <h3 className="text-xl font-bold">Release Summary</h3>

                <p className="mt-3 text-sm leading-6 text-white/90">
                  This release strengthens Netra APM across eight key areas,
                  delivering OTLP data ingestion, Virtual DB query error
                  identification, Java agent endpoint exclusion, expanded
                  alerting with redesigned alert pages and history, a new
                  database statements dashboard, exception analysis, and a
                  lighter infrastructure monitoring plugin.
                </p>

                <div className="mt-5 text-sm font-semibold">
                  Status: Major enhancements and platform improvements
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Zoom modal */}
      {zoomImage && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
          onClick={() => setZoomImage(null)}
        >
          <img
            src={zoomImage}
            alt="Zoomed Preview"
            className="max-w-[95vw] max-h-[90vh] object-contain transition-all duration-300"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}